const collection = [
  { id: 1, name: 'Gratitude', color: 'pink-300' },
  { id: 2, name: 'Memories', color: 'blue-300' },
  { id: 3, name: 'Notes', color: 'red-300' },
  { id: 4, name: 'Goals', color: 'indigo-400' },
  { id: 5, name: 'Thoughts', color: 'yellow-200' },
];

export default collection;
